import axios from "axios";

// export const ASSISTANT_API_URL = 'https://ai.tab-is.com:1082'; // prod

// export const ASSISTANT_API_URL = 'https://ai-test.tab-is.com:2082'; // test

// export const ASSISTANT_API_URL = "http://192.168.3.4:2802"; // test local

export const ASSISTANT_API_URL = "https://digital.tab-is.com:2082";  // dev

const token = localStorage.getItem("@storage_Token");

const $host = axios.create({
  baseURL: ASSISTANT_API_URL,
});

const $hostTest = axios.create({
  baseURL: ASSISTANT_API_URL,
  headers: {
    Authorization: token,
  },
});

const $authHost = axios.create({
  baseURL: ASSISTANT_API_URL,
  headers: {
    "Content-Type": `multipart/form-data`,
    Accept: "*/*",
    "Accept-Encoding": ["gzip", "deflate", "br", "*"],
    Connection: "keep-alive",
  },
});

const getToken = async () => {
  try {
    return await localStorage.getItem("@storage_Token");
  } catch (e) {
    // error reading value
  }
};

const authInterceptor = async (config) => {
  let token = await getToken();

  config.headers = {
    Authorization: `${token}`,
  };
  return config;
};

$authHost.interceptors.request.use(authInterceptor);
$hostTest.interceptors.request.use(authInterceptor);

$hostTest.interceptors.response.use(
  (response) => {
    // Если запрос успешен, просто возвращаем ответ
    return response;
  },
  (error) => {
    const { response } = error;

    // Проверка на ошибку с инвалидным токеном
    if (
      response &&
      response.data.statusEnum === "ErrTokenAccess" &&
      response.data.message === "invalid Access token"
    ) {
      // Очистка токена и разлогинивание
      localStorage.removeItem("@storage_Token");
      localStorage.removeItem("@user_Data");
      localStorage.removeItem("@storage_User_Id");
      
    }

    // Прокидываем ошибку дальше
    return Promise.reject(error);
  }
);

export { $authHost, $host, $hostTest };
